/* global grecaptcha, ContactFormData */
(function ($) {
    $(function () {
        const $form = $('#twenty-one-form-contact');
        $form.on('submit', function (event) {
            event.preventDefault();
            grecaptcha.reset();
            grecaptcha.execute();
        });

        window.formSubmit = function (response) {
            const url = $form.attr('action');
            $form.hide();
            $.ajax({
                type: 'POST',
                url: url,
                data: $form.serialize(),
                success: function () {
                    $('#twenty-one-form-contact-response').text(ContactFormData.successMessage);
                },
            });
        };
    });
})(jQuery);
